<form [formGroup]="characterForm" class="container">

	<character-wizard-nav
		(next)="nextStep()"
		(prev)="previousStep()"
		(submit)="submit()"
		[canSubmit]="canSubmit()"
		[isEdit]="!!characterId()"
		[maxStep]="maxStep"
		[step]="step()"
	/>

	@if (!canSubmit()) {
		<div class="alert alert-danger mt-3">
			<h6 class="mb-2">Impossible de valider le personnage :</h6>

			<ul class="mb-0">
				@for (err of getAllErrors(); track err) {
					<li>{{ err }}</li>
				}
			</ul>
		</div>
	}

	@switch (step()) {
		@case (1) {
			<app-step-1-basic
				[group]="basicGroup!"
				[meta]="metaGroup!"
			/>
		}
		@case (2) {
			<app-step-2-race
				[form]="raceGroup!"
				[commonRaces]="commonRaces()"
				[exoticRaces]="exoticRaces()"
			/>
		}
		@case (3) {
			<app-step-3-stats
				[group]="statsGroup!"
				[maximum]="maximumPoints()"
				[remaining]="remainingPoints()"
				[secondary]="secondaryStats()"
				[resources]="resources()"
			/>
		}
		@case (4) {
			<app-step-4-masteries
				[form]="progressionGroup!"
			/>
		}
		@case (5) {
			<app-step-5-skills
				[form]="progressionGroup!"
			/>
		}
		@case (6) {
			<app-step-6-inventory
				[form]="storyGroup!"
			/>
		}
		@case (7) {
			<app-step-7-backstory
				[form]="storyGroup!"
			/>
		}
	}

	<character-wizard-nav
		(next)="nextStep()"
		(prev)="previousStep()"
		(submit)="submit()"
		[canSubmit]="canSubmit()"
		[isEdit]="!!characterId()"
		[maxStep]="maxStep"
		[step]="step()"
	/>

</form>
